<template>
  <div class="container page">
    <van-nav-bar :title="$t('setbank.title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div class="tableItem" v-for="(item,key) in bankInfo" :key="key">
        <div class="weui-cell u-flex u-row-between"   @click="item.trs = !item.trs" >
          <div class="tableTitle u-flex u-flex-1 u-row-between" style="width: 90%;">
            <img class="w-[28rpx] h-[28rpx]" v-if="item.trs"   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJnSURBVHgBvVbRatRAFD0zKbtYrVZ9culCRVGsL4IfYH/DH9A/UAQfFnwQfeqr/oC/4Q8Igqi0tLRQaJ/abtnSsiHZ9Jwku+m2M02yXXrysNnMTM7MveeeXIMKSDq4hWPM83YOTTT4O5MPRbxOEHN0Fl3TwVHZu0wJ0T2EaCEgTRXE6HM7OyTer0VIogb3/Ig0s5gEGfEaicNSwuQD7jNgCyjCNhni9No0X3DoJUze4w539hjTRIQt8xl7w792RKYwNrCIacOgnb47RxG2EE8oDn8Y/+IlulhmdpYxwIP0WYA1rljFQ3xnEnad6wJe0gPwP+NHrsaYy1w4YCn8wxuK/zUuww38wBKJ76LnId6Uem1+upaX7De+lZIJmqO5WuNCzmHTovbVmU4WM9RVobla4wI5xGWRpA5yEdvcUZWTnYfWKN8u0K0sj+ou7i3PTqtA4nKhgTnrdZOoRijPo49XzucDNC3jHjgH4ysQDjwiZIlYXDMsWWPPyC4mhQzBBbqrZa76zsEmfmJSyH1c4DdIJ3Q7w/wVCGV1LhyL0FDELjzHr9Su6kJrFrzpOLR5WxA6h+WNvny4oLlLntORw3xFL1NphB3nFBnxC7ytdFLN0Vyfeeccow9w8hHP+M/fUsjq5D4yhGGNSskSl/KtFPgRmk/4o5vi+zeDDSiIPiNoc4dtdFAXWdmNVDveYmT9zCKmiR42zEohzDGnSXuPm1j3mkEd6B3qZ1bGq8DfJsZ4ChS9SC2oOW5ivVKbOEachbhVgziUGs92abUIR8Tv2DZE1OJtih9U8lBYQXrXZ1txxI11VWdl7zoFzxe4ziaYC2cAAAAASUVORK5CYII="
                />
            <img class="w-[28rpx] h-[28rpx]" v-else
                 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALfSURBVHgBvVYxb9NQEL57jtSw5QfQJoWIphISmYEGb7gsdQJDmFo2xoxsDRNrfgLZQILEXSBISJhWIHUimciQwRELG9lopMTH3YudmlZtUyXuJ+XFjl/ufPfuvvsQZsDGZvEB+mgDkAkKM0CQ0g8QBkTURsI2KXIOPja/XmQLz3tYsB5vs5MqX2ZgJpDHS3W/1azDZRyalp3xCZuAmA92DTiqmgLFEYw8t+V4ep9ppyCZyPvkb/Ee+/jFyBspNL9/aPQvdHjPKm4biLVJ2shTYDxzW+9cmAH/ZYQ43UA7B5+ae9E9RvRm42FxSyG+4cukjmhIT93PjS7MiH7vZ2f19lqdxpjkWxMRy9ezOe9Xr9s5FaFOI6ofQUHwOTRewhwoWKVdsSORjgzIh+lV4QYf1BftjCOb15lA20Co8SeVGJMT/q4mbyO5lwPnMxv6czubGl/StjwpvgLXxtRhcNCCqus6A1gQXMcZENJOaFsW1E1N6Ep03D+rEAMKm6U/clzs3FQIwiAMQgfiAteFfAlbKaYm3dwK1R7EBI7MDa44wpBNjkZtiAkGUcA4mFEhES+yWE4ipEJpEQVXDKWJmXH3USkNMcG07ck4Y9ZRwUiRPGcgJoyHeEe+uV7a7FB6kFdCE2JC2HoyrBWPkEn/EVQgLpCelbr1VCALPKkgYR1YMKI8LXM1qFKs6pXgtZ7iC8LE1jFPy6Id7rfe19lbWxpzvAS7sCCMr2lbmYCn61OH+oKoKC2CqCr3LXtup2IDSVXEpuib8PepxPB63UE6m/vNUdpcVebKzbXUjeXcoed1j+ASkDQur+deseB6IfdcmeVvrebhKYeCPmuPlVu5Nju0xCkloJzOrg/6EU1yHnTRJVRL/j8hFHrOIuptdM/ZMlEkR0T2yfgSsWv8pU7Iu8JOQhgcBU8BTl8okLnfRgbaM8nEKK5MCJ+EaT0xRezKKOPZlo9KfU6fRz650tSz6Nd/wtNJuVadtOUAAAAASUVORK5CYII="
            />
            <div class="u-flex u-flex-1 u-m-l-26">
              <div class="w-[180rpx] mr-[26rpx] u-line-2">{{ item.branch }}</div>
              <div class="u-line-1" style="max-width: 8.125rem;">{{ item.branch_number }}</div>
            </div><!--v-if--></div>
          <div class="w-[28rpx] h-[28rpx] u-flex">
            <img class="w-[28rpx] h-[28rpx]"  v-if="item.trs" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACjSURBVHgB7dOxCUIxFIXhc6IWdo6Q0kYMuIAjuIEPXEtnMfaCjWCrGziAejWChUJ4ueF13r8LyeGrAliW9XcRynxoRsMelgJe+XDxdNhcNHsVOA6N58BtCfp0FsgZN841aDH4i33SokVgDqtBW8E2TIuyC0yDsiusFHW5YQ323qVNX2L6PsVgeD2uwb7Q7F2myWy1uFOmqMjB7Y77dYRlWVbqCYzuSa/Xyui/AAAAAElFTkSuQmCC"
            />
            <img class="w-[28rpx] h-[28rpx]" v-else src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACxSURBVHgB7dKhDsIwEIDha5spzHiDyckZEtzGm4wHI8Aj8ASgUIgqsMcTgCAISFdmQJB1uyuS+1XT6+UzBZAk6e9SoUE+mZfaqwqi8vZ4WG7IYFHU6SMxF/ih+9ON0a6u3/e6ZwchPuzCgqBtHzfGzSJR9AlUoaHq28yndaad2bbHDBjYab84QwzIRAcxEkhESRgZHEDJGAsMoCyMDb5R05hSeUhvI7fGXff3lyRJ+vQCnXFOgOPbmjYAAAAASUVORK5CYII="
               />

          </div>
        </div>
        <div class="details"  v-if="item.trs">
          <div>
            <span class="w-[170rpx] mr-[16rpx]"><span>{{ $t("银行名称") }}</span></span>
            <span class="right u-flex-1"><span>{{ item.branch }}</span></span>
          </div>
          <div>
            <div class="w-[170rpx] mr-[16rpx]">{{ $t("账户持有人") }}</div>
            <div class="right u-flex-1 u-line-1" style="max-width: 10.9375rem;">{{ item.branch_number }}</div>
          </div>
          <div>
            <span class="w-[170rpx] mr-[16rpx]"><span>{{ $t("账号") }}</span></span>
            <span class="right u-flex-1"><span>{{ item.bankid }}</span></span>
          </div>
        </div>
      </div>


      <div class="tips">{{ $t('setbank.hint') }}</div>

      <van-button class="bindCard" type="default" @click="toBindCard()">{{ $t("setbank.bank") }}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind: false,
      bankInfo: {},
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
            this.bankInfo = res.data.info;
          } else {
            this.is_bind = false;
          }
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    toBindCard() {
      /*if (!this.userInfo.name) {
        this.$router.push("Setname?type=1");
        this.$toast(this.$t("msg.请设置姓名后再绑定银行卡！"));
        return true;
      }else */
      if (!this.userInfo.paypassword) {
        this.$router.push("SetPayPassword?type=1");
        this.$toast(this.$t("msg.请设置提现密码后再绑定银行卡！"));
        return true;
      } else {
        this.$router.push({path: '/BindCard'})
      }
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.wrapper{
  margin: 50px 50px;
}
/*.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.container p {
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}

.manage-card .wrapper {
  height: calc(100% - 10px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.wrapper .add-card {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  background-color: #fff;
  height: 250px;
}

.wrapper .add-card span {
  margin-left: 10px;
  font-size: 30px;
}

.wrapper .tips {
  margin: 15px 15px;
  font-size: 25px;
  color: #979799;
}

.wrapper .bank .info {
  margin-left: 20px;
  flex: 1;
  color: #000;
}

.wrapper .bank .info .row-content {
  margin: 30px 0;
  line-height: 20px;
  font-size: 30px;
}*/
.tableItem {
  margin-bottom: 1.25rem;
  background: #ffffff;
  border-radius: .5rem;
}
.tableItem .weui-cell {
  padding: 0 1.1875rem 0 .875rem;
  height: 3.625rem;
  background: #dfe8f6;
  border-radius: .5rem
}

.tableItem .details {
  font-size: .875rem;
  padding: .75rem .625rem 1rem;
  border-radius: .375rem
}

.tableItem .details>div {
  height: 3.125rem;
  padding: 0 .75rem;
  margin-bottom: .75rem;
  display: flex;
  align-items: center;
  background-color: #dfe8f6;
  border-radius: .5rem
}

.tableItem .details>div span {
  display: flex;
  align-items: center
}

.tableItem .details .delBtn {
  height: 2.75rem;
  background-color: #308ee3;
  margin-bottom: 0
}
.weui-cell {
  display: flex;
  align-items: center;
  position: relative;
}
.u-row-between {
  justify-content: space-between;
}
.u-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.u-flex-1 {
  flex: 1;
}
.u-row-between {
  justify-content: space-between;
}
.w-\[28rpx\] {
  width: 30px;
}
.h-\[28rpx\] {
  height: 30px;
}
.u-line-1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.u-m-l-26 {
  margin-left: .8125rem !important;
}
.u-line-2, .u-line-3, .u-line-4, .u-line-5 {
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.u-line-2 {
  -webkit-line-clamp: 2;
}
.w-\[180rpx\] {
  width: 180px;
}
.mr-\[26rpx\] {
  margin-right: 26px;
}
.w-\[170rpx\] {
  width: 170px;
}
.mr-\[16rpx\] {
  margin-right: 16px;
}
.bindCard {
  width: 100%;
  margin-top: 50px;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 10px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(99.09deg, #66bcff 0%, #ec1d25 100%)
}
</style>
